var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#134563;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Close",
    transform: "translate(381.000000, 231.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    id: "Fill-16",
    points: "-370.7,-174.7 -373,-177 -327,-223 -324.7,-220.7 -370.7,-174.7    "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    id: "Fill-17",
    points: "-327,-174.7 -373,-220.7 -370.7,-223 -324.7,-177 -327,-174.7    "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXicon);
export default __webpack_public_path__ + "static/media/xicon.47125aa2efefeb9d6d0278bea2f74f09.svg";
export { ForwardRef as ReactComponent };